module.exports = __webpack_public_path__ + "static/infocontpaq1-image-3ad8fbb0b55690dc065fbc7ece4f3b23.png";